<template>
  <div id="app" class="c-pos-r">
    <sq-swipe v-if="swipe.show" :data="swipe"></sq-swipe>
    <sq-header></sq-header>
    <sq-content></sq-content>
    <sq-footer></sq-footer>
    <sq-comment-area></sq-comment-area>
    <sq-func-buttons></sq-func-buttons>
    <sq-share></sq-share>
  </div>
</template>

<script>
import Header from '@/components/header/header'
import Content from '@/components/content/content'
import Footer from '@/components/footer/footer'
import Swipe from '@/components/swipe/swipe'
import CommentArea from '@/components/footer/commentArea'
import FuncButtons from '@/components/funcButtons/funcButtons'
import Share from '@/components/share/share'
export default {
  name: 'app',

  components: {
    'sq-header': Header,
    'sq-content': Content,
    'sq-footer': Footer,
    'sq-swipe': Swipe,
    'sq-comment-area': CommentArea,
    'sq-func-buttons': FuncButtons,
    'sq-share': Share
  },

  mounted () {
    this.$store.dispatch('getPageInfo')
  },

  computed: {
    swipe () {
      return this.$store.state.swipe
    }
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?2fd5b0fd